import React from 'react';
import styled, { keyframes } from 'styled-components';
import { FaQuoteLeft, FaLinkedin } from 'react-icons/fa';

const RecommendationsContainer = styled.section`
  padding: 80px 5%;
  max-width: 1200px;
  margin: 0 auto;
  background-color: #f3f4f6; /* Light gray background */
`;

const SectionTitle = styled.h2`
  font-size: 2.5rem;
  text-align: center;
  margin-bottom: 60px;
  color: #1f2937; /* Dark gray text */
  position: relative;
  
  &::after {
    content: '';
    display: block;
    width: 80px;
    height: 4px;
    background: #2563eb; /* Primary blue */
    margin: 15px auto 0;
  }
`;

const RecommendationsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 30px;
  margin: 0 auto;
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const RecommendationCard = styled.div`
  animation: ${fadeIn} 0.6s ease-out forwards;
  background: #ffffff; /* White background */
  border-radius: 10px;
  padding: 30px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  opacity: 0; /* Start with 0 opacity, animation will make it visible */
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  }
  
  /* Staggered animation for each card */
  &:nth-child(1) { animation-delay: 0.1s; }
  &:nth-child(2) { animation-delay: 0.3s; }
  &:nth-child(3) { animation-delay: 0.5s; }
`;

const QuoteIcon = styled.div`
  color: #1f2937; /* Dark gray text */
  text-align: center;
  margin-bottom: 20px;
  opacity: 0.7;
`;

const QuoteText = styled.p`
  color: #1f2937; /* Dark gray text */
  line-height: 1.6;
  margin-bottom: 20px;
`;

const AuthorContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 20px;
`;

const AuthorInfo = styled.div`
  flex: 1;
`;

const AuthorName = styled.h4`
  margin: 0;
  color: #1f2937; /* Dark gray text */
  font-size: 1.1rem;
`;

const AuthorTitle = styled.p`
  margin: 5px 0 0;
  color: #6b7280; /* Gray text */
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 5px;
`;

const LinkedInLink = styled.a`
  color: #0a66c2; /* LinkedIn blue */
  margin-left: 5px;
  transition: color 0.2s ease;
  
  &:hover {
    color: #004182; /* Darker blue on hover */
  }
`;



const recommendations = [
  {
    id: 1,
    text: "Akash is hard working, meticulous and very dependable resource in a team. His code is of high quality and he is a quick learner. Akash can go that extra mile that is required at the time of delivery. His contributions to team discussions and brainstorming of ideas was very valuable. I would highly recommend him.",
    author: "Ashish Nigam",
    title: "Technical Architect",
    linkedin: "https://www.linkedin.com/in/ashish-nigam-1976307/"
  },
  {
    id: 2,
    text: "He is good team player and having strong technical skills",
    author: "Vinod Patel",
    title: "Scrum master/Technology Specialist",
    linkedin: "https://www.linkedin.com/in/vinod-patel-911628a8/"
  }
];

const Recommendations = () => {
  return (
    <RecommendationsContainer id="recommendations">
      <SectionTitle>What Colleagues Say</SectionTitle>
      <RecommendationsGrid>
        {recommendations.map((recommendation) => (
          <RecommendationCard key={recommendation.id}>
            <QuoteIcon>
              <FaQuoteLeft />
            </QuoteIcon>
            <QuoteText>{recommendation.text}</QuoteText>
            <AuthorContainer>
              <AuthorInfo>
                <AuthorName>{recommendation.author}</AuthorName>
                <AuthorTitle>
                  {recommendation.title}
                  {recommendation.linkedin && (
                    <LinkedInLink 
                      href={recommendation.linkedin} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      aria-label={`${recommendation.author}'s LinkedIn profile`}
                    >
                      <FaLinkedin size={16} />
                    </LinkedInLink>
                  )}
                </AuthorTitle>
              </AuthorInfo>

            </AuthorContainer>
          </RecommendationCard>
        ))}
      </RecommendationsGrid>
    </RecommendationsContainer>
  );
};

export default Recommendations;
